module.exports = __webpack_public_path__ + "static/img/PFK_OurTeam_Photo4_ThankYou_260x260.bf8c1c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_OurTeam_Photo4_ThankYou_260x260.jpg
// module id = 172
// module chunks = 2